export const COLOR_LIST = ["#FFB400", "#FF5A5F", "#8CE071", "#00D1C1", "#007A87", "#7B0051"]

export const PEGS_PER_ATTEMPT = 4;

export const DEFAULT_PEG_COLOR = "white";

export const DEFAULT_HINT_COLOR = "white";

export const TOTAL_ATTEMPTS = 10;

export const INITIAL_GAME_STATE = {
    "selectedColor" : "",
    "attemptsMade" : 0
};

